import React from 'react';
import { track, trackException } from '../lib/track';

/**
 * Catches render crashes so partner visits surface as dashboard_crash
 * (and $exception) instead of a silent white screen.
 */
export default class DashboardErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const dashboard = this.props.dashboard || 'unknown';
    trackException(error, {
      dashboard,
      context: 'dashboard_error_boundary',
      component_stack: info?.componentStack?.slice?.(0, 500),
    });
    track('dashboard_crash', {
      dashboard,
      error_name: error?.name || 'Error',
      error_message: String(error?.message || error).slice(0, 240),
    });
  }

  render() {
    if (this.state.error) {
      const msg = String(this.state.error?.message || this.state.error);
      return (
        <div className="error-screen">
          <h2>This desk view failed to load</h2>
          <p>
            We captured the error for engineering. Try another tab, or refresh after a deploy.
          </p>
          <p className="engine-note" style={{ marginTop: 12 }}>
            {msg}
          </p>
          <button
            type="button"
            className="btn-secondary"
            style={{ marginTop: 16 }}
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
